import type React from 'react';

import { LoyaltyChip } from '../LoyaltyChip';

import { CartButton } from './components/CartButton';
import { FavoriteButton } from './components/FavoriteButton';
import { ProfileButton } from './components/ProfileButton';
import styles from './UserActions.module.scss';

export const UserActions: React.FC = () => {
  return (
    <div className={styles.actionButtons}>
      <FavoriteButton />
      <LoyaltyChip />
      <ProfileButton />
      <CartButton />
    </div>
  );
};
